<mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
</mat-card-header>

<mat-card-content class="mat-card-style-kc-search-result">
    <div class="table-responsive">
        <table #table mat-table multiTemplateDataRows [dataSource]="dataSourceSearchResultDisplay">

            <ng-container matColumnDef="occureDate">
                <th mat-header-cell class="border-bottom-double" style="width: 8%" *matHeaderCellDef>発生日</th>
                <td mat-cell *matCellDef="let row">{{row.occureDate}}</td>
            </ng-container>
            <ng-container matColumnDef="suppntSpno">
                <th mat-header-cell class="border-bottom-double" style="width: 12%" *matHeaderCellDef>供給地点特定番号</th>
                <td mat-cell *matCellDef="let row" style="white-space: pre-line;">{{formattedText(row.suppntSpno)}}</td>
            </ng-container>
            <ng-container matColumnDef="userMei">
                <th mat-header-cell class="border-bottom-double" style="width: 16%" *matHeaderCellDef>ご使用者名</th>
                <td mat-cell *matCellDef="let row">{{row.userMei}}</td>
            </ng-container>
            <ng-container matColumnDef="targetYm">
                <th mat-header-cell class="border-bottom-double" style="width: 6%" *matHeaderCellDef>対象年月</th>
                <td mat-cell *matCellDef="let row">{{row.targetYm}}</td>
            </ng-container>
            <ng-container matColumnDef="usageStartdate">
                <th mat-header-cell class="border-bottom-double" style="width: 8%" *matHeaderCellDef>使用開始日</th>
                <td mat-cell *matCellDef="let row">{{row.usageStartdate}}</td>
            </ng-container>
            <ng-container matColumnDef="usageEnddt">
                <th mat-header-cell class="border-bottom-double" style="width: 8%" *matHeaderCellDef>使用終了日</th>
                <td mat-cell *matCellDef="let row">{{row.usageEnddt}}</td>
            </ng-container>
            <ng-container matColumnDef="empday">
                <th mat-header-cell class="border-bottom-double" style="width: 6%" *matHeaderCellDef>使用日数</th>
                <td mat-cell *matCellDef="let row">{{row.empday}}</td>
            </ng-container>
            <ng-container matColumnDef="empamt">
                <th mat-header-cell class="border-bottom-double" style="width: 10%" *matHeaderCellDef>使用量</th>
                <div *ngIf="suppntSpno.length === 17">
                    <td mat-cell style="text-align: right;" *matCellDef="let row">{{row.empamt}}<span>㎥</span></td>
                </div>
                <div *ngIf="suppntSpno.length === 22">
                    <td mat-cell style="text-align: right;" *matCellDef="let row">{{row.empamt}}<span>kWh</span></td>
                </div>
            </ng-container>

            <ng-container matColumnDef="reimportTrnStatuscode">
                <th mat-header-cell class="border-bottom-double" style="width: 8%" *matHeaderCellDef>ステータス</th>
                <td mat-cell *matCellDef="let row">
                    <mat-form-field appearance="standard">
                        <mat-select data-testid="status-select" [(ngModel)]="reimpGrpNoAndStatusCodeMap[row.reimportGroupNo]"
                            [disabled]="isReimportStatus(row.reimportTrnStatuscode)">
                            <div *ngIf="isReimportStatus(row.reimportTrnStatuscode)">
                                <mat-option *ngFor="let status of statusList" [value]="status.value">
                                    {{ status.viewValue }}
                                </mat-option>
                            </div>
                            <div *ngIf="!isReimportStatus(row.reimportTrnStatuscode)">
                                <mat-option *ngFor="let status of tableDataStatusList" [value]="status.value"
                                    (onSelectionChange)="onStatusChanged(row.reimportGroupNo, status.value, $event)">
                                    {{ status.viewValue }}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="biko">
                <th mat-header-cell class="border-bottom-double" style="width: 18%" *matHeaderCellDef>備考</th>
                <td mat-cell *matCellDef="let row">{{row.biko}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
            <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"
                [class.disabled-row]="isReimportStatus(row.reimportTrnStatuscode)"
                [attr.aria-disabled]="isReimportStatus(row.reimportTrnStatuscode) ? true : null"></tr>
        </table>
    </div>

    <div class="tw-flex tw-flex-row tw-items-center tw-justify-end tw-box-border tw-grow tw-shrink tw-basis-full">
        <mat-card-actions class="btn_area_right">
            <button type="button" mat-raised-button color="primary" class="btn"
                (click)="onClickRegistration()">登録</button>
        </mat-card-actions>
    </div>

</mat-card-content>